/**
 * 获取图片文件的分辨率
 * @param {*} file 文件
 * @returns promise
 */
export function getImgResolution(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function () {
      if (reader.readyState === 2) {
        const img = new Image()
        img.src = reader.result
        img.onload = function (e) {
          resolve({ width: this.width, height: this.height })
        }
      }
    }
  })
}
